'use strict';

export default function BeaconsService($http, $q, CreativeService) {
  var vm = this;

  vm.initializeDisplayBeacons = initializeDisplayBeacons;
  vm.impressionBeacons = impressionBeacons;
  vm.clickBeacons = clickBeacons;
  vm.get = get;
  vm.validBeacons = validBeacons;
  vm.validate = validate;
  vm.beaconHasError = beaconHasError;
  vm.validateAllBeacons = validateAllBeacons;
  vm.requiredBeacons = requiredBeacons;
  /* This is a GDPR-related field with a confusing name. Required=true
   * means DO NOT BID on the impression if this tracker is
   * present. Required=false means bidding is allowed, but do not fire
   * this tracker. NAG assumes it's a flag that applies globally to
   * all beacons */
  // TODO: apply per creative for multi creative flow
  vm.required = null;

  function impressionBeacons(creative) {
    if (!creative || !creative.beacons) {
      return [];
    }
    return creative.beacons.filter(beacon => beacon.event === 'impression');
  }

  function clickBeacons(creative) {
    if (!creative || !creative.beacons) {
      return [];
    }
    return creative.beacons.filter(beacon => beacon.event === 'click');
  }

  function validBeacons(beacons = []) {
    return beacons.filter(beacon => beacon.url !== null && beacon.url !== '');
  }

  function beaconHasError(beacon) {
    /* validations haven't finished yet for this beacon, so don't
     * indicate an error state until they have */
    if (beacon.urlValid === undefined && beacon.gdprCompliant === undefined) {
      return false;
    }
    return !beacon.urlValid || !beacon.gdprCompliant;
  }

  function validate(beacon) {
    return $q.resolve().then(function() {
      if (!beacon.url) {
        beacon.urlValid = true;
        return;
      }

      return $http
        .post('/beacons/validate', {
          url: beacon.url,
          applyGdprValidations: CreativeService.creative.runningInEu
        })
        .then(function(response) {
          beacon.urlValid = response.data.urlValid;
          beacon.gdprCompliant = response.data.gdprCompliant;

          if (response.data.vendor) {
            beacon.gdprVendor = response.data.vendor.vendorId;
          }
        })
        .catch(() => {
          beacon.urlValid = false;
          beacon.gdprCompliant = null;
        });
    });
  }

  /**
   * Fire and forget all the validate calls, since each call handles
   * one specific beacon's validation state
   */
  function validateAllBeacons(beacons = []) {
    for (let beacon of beacons) {
      validate(beacon);
    }
  }

  // if a creative key is present, get them, else return promise;
  function get() {
    var creativeKey = CreativeService.creative.privateKey;

    if (creativeKey) {
      return $http.get('/beacons/' + creativeKey).then(function(response) {
        vm.beacons = response.data;

        /* For populating the page on load, just take the first
           * beacon's required setting (since the NAG assumes it's
           * global across all beacons */
        if (response.data.length > 0) {
          vm.required = response.data[0].required;
        }
      });
    } else {
      return $q.resolve();
    }
  }

  // set default (blank) display beacons
  function initializeDisplayBeacons(creative) {
    creative.beacons = creative.beacons || [];

    return get(creative.privateKey).then(function() {
      if (impressionBeacons(creative).length === 0) {
        creative.beacons.push({ event: 'impression', url: null });
      }

      if (clickBeacons(creative).length === 0) {
        creative.beacons.push({ event: 'click', url: null });
      }
    });
  }

  function requiredBeacons(orignalBeacons, required) {
    let beacons = JSON.parse(JSON.stringify(orignalBeacons));
    // not null/undefined!
    if (required === true || required === false) {
      beacons.forEach(beacon => {
        beacon.required = required;
      });
    }

    return beacons;
  }

  return vm;
}

BeaconsService.$inject = ['$http', '$q', 'CreativeService'];
